module.exports = __webpack_public_path__ + "head.a2d2cde9.png";